import { PropsWithChildren } from "react";

const SurveyQuestion: React.FC<
  PropsWithChildren<{
    ordinal: number;
    question: string;
  }>
> = ({ ordinal, question, children }) => (
  <div className="flex items-start gap-2 mb-2">
    <span className="rounded-full bg-white font-bold text-[13px] text-blue w-[20px] h-[20px] flex items-center justify-center border-blue border-[2px] leading-[20.8px]">
      {ordinal}
    </span>
    <fieldset className="flex flex-col gap-0.5">
      <legend className="capitalize text-sm">
        {question}
        <span className="text-red200"> *</span>
      </legend>
      {children}
    </fieldset>
  </div>
);

export default SurveyQuestion;
